import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=0e7d5d97&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"
import style0 from "../../style/common-m.scss?vue&type=style&index=0&id=0e7d5d97&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7d5d97",
  null
  
)

export default component.exports